import React from "react";

const termsNconds = () => (
  <>
    <div id="popup">
      <table
        style={{
          width: "100%",
          border: "0",
          cellspacing: "0",
          cellpadding: "0",
        }}
      >
        <tr>
          <td
            style={{
              borderBottom: "2px solid #e20a16",
              padding: "10px 0px 5px 10px;",
            }}
          >
            <img src="/tnc.png" alt="" width="170" height="85" />
          </td>
        </tr>
        <tr>
          <td
            style={{
              fontFamily: "Tahoma, sans-serif",
              fontSize: "23px",
              padding: "10px 0 5px 10px",
              color: "#e20a16",
            }}
          >
            TCS Service Agreement Form (Terms &amp; Conditions)
          </td>
        </tr>
        <tr>
          <td
            style={{
              fontFamily: "Tahoma, sans-serif",
              fontSize: "15px",
              padding: "10px 0 5px 10px",
              color: "#666666",
            }}
          >
            The Shipper/Sender/Client acknowledges and accepts these terms and
            conditions and relieving TCS (Pvt.) Limited along with all of its
            affiliated/associated/group companies (hereinafter referred to as
            &ldquo;TCS&rdquo;) from any liabilities, responsibilities, claims,
            proceedings, suits, etc. against any damage, loss or expense
            suffered in connection with the services hereunder and also agreeing
            that TCS will only be responsible for the carriage of
            parcel/goods/cargo which is the only function and responsibility of
            TCS.
          </td>
        </tr>
        <tr>
          <td
            style={{
              fontFamily: "Tahoma, sans-serif",
              fontSize: "15px",
              padding: "10px 0 5px 10px",
              color: "#666666",
            }}
          >
            <ol>
              <li>
                <span dir="ltr"> </span>
                <strong>TCS Consignment Note:</strong>
              </li>
              <p>
                The Consignment Note of TCS (hereinafter referred to as
                &ldquo;CN&rdquo;) is non-negotiable and the
                Shipper/Sender/Client acknowledges that it has been prepared by
                the Shipper/Sender/Client or by TCS staff on behalf of the
                Shipper/Sender/Client. The Shipper/Sender/Client confirms that
                all the information provided to TCS while booking the shipment
                are complete and correct including Shippers and Consignee
                details, goods value declaration etc. The Shipper/Sender/Client
                warrants that it is the owner of the parcel/goods/cargo, or that
                it is the authorized agent of the owner of the goods. In case of
                any incorrect information or declaration in the CN, the
                Shipper/Sender/Client acknowledges that TCS will be absolved
                from any liability or responsibility pertaining to loss, damage
                or expense suffered by the Shipper/Sender/Client. The execution
                of this consignment note is prima facie evidence of the
                conclusions of contract between shipper and TCS.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>No Variation</strong>
                <strong>:</strong>
                <strong> </strong>
              </li>
              <p>
                These terms and conditions are applicable on all courier,
                logistics and all other services provided by TCS to the
                Shipper/Sender/Client hereunder. No employee, franchisee, agent
                of TCS or anyone else has any authority to change any of these
                terms and conditions, or make any promise on behalf of TCS which
                is in addition to or in conflict with these Terms and
                Conditions.
                <strong></strong>
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Right of Inspection of Shipment: </strong>
              </li>
              <p>
                TCS has the right, but not the obligation, to inspect any
                shipment including without limitation opening the shipment if
                required by law and/or regulations. In this regard, the
                Shipper/Sender/Client agrees that TCS may open and inspect a
                shipment for any reason at any time as per its discretion. In
                that event TCS will exercise all the reasonable care, but it
                shall not be liable for any damage to the shipment or any delay
                of the shipment or post arising as a result of any such
                examination.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Lien of Goods Shipped: </strong>
              </li>
              <p>
                TCS shall have a lien on any goods shipped for all freight
                Charges, Octroi, duties, advances or any other charges of any
                kind payable by the Shipper/Sender/Client hereunder and may
                refuse to surrender possession of the goods until such charges
                are paid.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Limitation of Liability:</strong>
                <br />
                <p>
                  The Shipper/Sender/Client agrees that in case of any damage or
                  loss to the shipment or any part thereof, the maximum
                  liability of TCS to pay any compensation for damage or loss or
                  failure to deliver the consignment shall be limited to the{" "}
                  <u>lowest</u> of the following:
                </p>
                <ul>
                  <li>
                    <span dir="ltr"> </span>
                    <strong>Documents:</strong>
                    <br />
                    For original documents, such as Educational
                    Degrees/Certificates, Passport, Immigration Documents, CNIC,
                    Vehicle Documents, and Property Documents, TCS is to pay for
                    reconstruction costs in the event of loss or damage.
                  </li>
                  <li>
                    <span dir="ltr"> </span>
                    <strong> Parcels: </strong>
                    <br />
                    PKR. 500/- (Rupee Five Hundred only) per kilogram in case of
                    parcel shipments with origin destination within Pakistan).
                    The above shall be in addition to refund of freight charges.
                  </li>
                  <li>
                    <span dir="ltr"> </span>For the safe transportation of the
                    Consignment, TCS shall exercise extreme care as per the
                    business standards. However, all the insurances, including
                    but not limited to insurance in transit shall be the
                    exclusive responsibility of the Customer. At the request of
                    the Customer, insurance coverage may be arranged by TCS if
                    intimation is given in advance. In which case terms and
                    conditions including rate of premium charged by TCS for
                    insurance shall be acceptable to the Customer.{" "}
                  </li>
                  <li>
                    <span dir="ltr"> </span>Save as provided above where the
                    responsibility of insurance of Consignment in transit rests
                    with the Customer or any party other than TCS, TCS limits
                    its liability to the lowest of the following:
                    <p>
                      i)&nbsp;&nbsp;&nbsp;Refund of freight charges in case of
                      International Document shipment with destination or Origin
                      outside Pakistan.
                      <br />
                      ii)&nbsp;&nbsp;&nbsp;Refund of freight charges and
                      declared value of the contents in case of International
                      non-Document / parcel shipment with Destination and Origin
                      outside Pakistan.
                      <br />
                      iii)&nbsp;&nbsp;&nbsp;In case of multiple piece
                      international shipments, only the freight charges and the
                      declared value of the lost/damaged piece will be refunded.
                      <br />
                      iv)&nbsp;&nbsp;&nbsp;In any case TCS’s maximum liability
                      for loss or damage of uninsured international Shipment
                      shall not exceed US $100 (even if the declared value of
                      the uninsured Shipment exceeds US $100).
                    </p>
                  </li>
                  <li>
                    <span dir="ltr"> </span>TCS’s liability in respect of any
                    Shipment transported by Air is limited by the Montreal
                    Convention or the Warsaw Convention as applicable, or in the
                    absence of such Convention, to the lower of the current
                    market or declared value and Freight Charges.{" "}
                  </li>
                  <li>
                    <span dir="ltr"> </span>The actual value of the document or
                    parcel (lost or damaged), as defined in clause 6 below,
                    without regard to its commercial utility or special value to
                    the Shipper/Sender/Client, provided the said loss or damage
                    is suffered solely due to negligence and willful act of TCS
                    (proof of negligence and willful act of default on part of
                    TCS will be required).{" "}
                  </li>
                  <li>
                    <span dir="ltr"> </span>The Shipper/Sender/Client will
                    indemnify and keep TCS fully indemnified from and against
                    all claims, proceedings, costs, expenses, liability, injury,
                    duties, taxes, import duties, loss or damage in respect of;
                    <p>
                      i)&nbsp;&nbsp;&nbsp;Any breach of this agreement by the
                      shipper/Sender/Client;
                      <br />
                      ii)&nbsp;&nbsp;&nbsp;Any injury or death of any person or
                      damage to any property arising directly or indirectly from
                      any act, omission, default, negligence of the
                      Shipper/Sender/Client or its agents;
                      <br />
                      iii)&nbsp;&nbsp;&nbsp;Any claim, cost or demand whatsoever
                      by whomsoever made in excess of the liability of TCS under
                      these conditions in respect of loss, damage or injury
                      howsoever caused, whether or not by the negligent act of
                      TCS, its servants, agents, franchisee or sub-contractors;
                      <br />
                      iv)&nbsp;&nbsp;&nbsp;The Shipper/Sender/Client undertakes
                      that no claim shall be made against any Director, Servant,
                      Employee, Agent, Franchisee, or Sub-Contractors of TCS
                      which imposes or attempts to impose upon them any
                      liability in connection with any services which are
                      subject to these conditions, and without prejudice to the
                      foregoing, if any such claim is made, to indemnify TCS
                      against all consequences of such a claim.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <span dir="ltr"> </span>
                <strong>Actual Value: </strong>
              </li>
              <ul>
                <li>
                  <span dir="ltr"> </span>The actual value of a document (which
                  terms shall include any item of no commercial value which is
                  transported hereunder) shall be ascertained by reference to
                  the <u>lowest</u> of either its cost of its preparation or
                  replacement or reconstruction value at the time and place of
                  shipment, whichever is less;
                </li>
                <li>
                  <span dir="ltr"> </span>The actual value of a
                  parcel/goods/cargo (which terms shall include any item of
                  commercial value which is transported hereunder) shall be
                  ascertained by reference to the <u>lowest </u>of either its
                  cost of preparation or replacement or repairing or fair market
                  value at the time and place of shipment, whichever is less. In
                  no event shall such value exceed the original cost of the
                  parcel/goods/cargo actually paid by the Shipper/Sender/Client.
                </li>
              </ul>
              <br />
              <li>
                <span dir="ltr"> </span>
                <strong>Consequential Damages Exclusion: </strong>
              </li>
              <p>
                TCS shall not be liable in any consequential or special damages
                or other indirect loss, however arising, whether or not TCS had
                knowledge that such damages might be incurred, including but
                limited to loss of income, profit, interest, use of contents or
                loss of market.{" "}
              </p>
              <br />
              <li>
                <span dir="ltr"> </span>
                <strong>Liabilities Not Assumed: </strong>
              </li>
              <p>
                The Shipper/Sender/Client acknowledges that the
                consignment/shipment shall be transported by road and/or air and
                shall therefore be exposed to all risks usually to be associated
                with such mode of transportation. Subject to the aforesaid, TCS
                will endeavor to exercise its best efforts to provide
                expeditious delivery in accordance with the regular delivery
                schedule. however, TCS will not, under any circumstances be
                liable for delay in pick up, transport or delivery of any
                shipment regardless of the cause of such delay. Further TCS
                shall not be liable if a shipment is lost, damaged,
                mis-delivered or not delivered because of circumstances beyond
                its control. These include but not limited to;
              </p>
              <ul>
                <li>
                  <span dir="ltr"> </span>&ldquo;Act of God&rdquo; for example
                  including earthquake, cyclone, storm, flood or &ldquo;force
                  majeure&rdquo;. For the purposes of these terms and
                  conditions, &ldquo;Force Majeure&rdquo; means an event which
                  is beyond the reasonable control of TCS and making it
                  impossible for the purpose of performing its
                  obligations/duties. TCS shall neither be held liable for any
                  delay in or failure to perform or observe its obligations
                  under this terms and conditions, if such failures or delays
                  are caused by &ldquo;Force Majeure&rdquo; which includes acts
                  of God such as earthquake, flooding and lightening, wars,
                  riots, stoppage, accident, explosion, fire, government
                  restrictions, act of terrorism or any other cause beyond the
                  reasonable control of TCS. In the event of the occurrence of
                  any of the foregoing, the date of performance shall be
                  deferred for a period of time equal to the time lost by reason
                  of the delay.{" "}
                </li>
                <li>
                  <span dir="ltr"> </span>The act, default or omission of the
                  Shipper/Client/Sender or any other party who claims an
                  interest in the shipment (include violation of any terms and
                  condition hereof) or any person other than TCS or of any
                  Government officials or of the Postal service forwarded or
                  other entity or person to whom a shipment is tendered by TCS
                  or transportation to any location not regularly served by TCS
                  regardless of whether the Shipper/Client/Sender reported or
                  had knowledge of such third party delivery arrangements.{" "}
                </li>
                <li>
                  <span dir="ltr"> </span>The nature of the shipment for any
                  defect, characteristic, inherent vice thereof, even if known
                  to TCS when the Shipper/Client/Sender accepted it.
                </li>
                <li>
                  <span dir="ltr"> </span>Electrical or magnetic energy erasure
                  or other such damage to electronic or photographic images or
                  recording in any form.{" "}
                </li>
              </ul>
              <br />
              <li>
                <span dir="ltr"> </span>
                <strong>Claims: </strong>
              </li>
              <p>
                (1) If the Shipper/Client/Sender is dissatisfied with the
                service of TCS, the Shipper/Client/Sender must notify TCS in
                writing: <br />
                (i) within 30 days from the date the Shipment was tendered to
                TCS in the case of alleged loss of the shipment, or
                <br />
                &nbsp;(ii) 14 days of receipt of the Shipment in the case of
                alleged damage. TCS reserves the right to decline to accept any
                claim not so notified. <br />
                (2) In the absence of any such notification, the
                Shipper/Client/Sender is deemed to have accepted that the
                service has been provided satisfactorily and that the Shipment
                has been delivered in accordance with the terms of the agreement
                between TCS and the Shipper/Client/Sender. <br />
                (3) In any event, TCS will be under no liability to accept any
                claim unless and until the Shipper/Client/Sender has paid to TCS
                all charges due under the business arrangement. The
                Shipper/Client/Sender must not set off the amount of this claim
                against those charges.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Applicability: </strong>
              </li>
              <p>
                These term and conditions shall apply to and insure to benefit
                TCS (Pvt.) Limited along with all of its
                affiliated/associated/group companies, and their officers,
                directors and employees.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Material Not Acceptable For Transportation:</strong>
              </li>
              <p>
                TCS does not accept as a shipment; Currency, Jewelry, Bullion,
                Antiques, Liquor, Stamps, Precious Metals, Precious Stones,
                Contraband, no customs declaration is made when required by
                applicable customs regulations, Work of Art, Fire arms, Plants,
                Drugs, Explosives, Animals, Perishable, Negotiable Instruments
                in bearer Form, Lewd, Obscene or Pornographic Materials,
                Industrial Carbons and Diamonds, its packaging is defective or
                inadequate, items/articles restricted by IATA (International Air
                Transport Association) or ICAO (International Civil Aviation
                Organization) or Warsaw Convention relating to International
                Carriage by Air, hazardous or combustible material or any other
                item which is notified by TCS from time to time to be a
                prohibited item in accordance with this paragraph, property of
                carriage of which is prohibited by any law, regulation or
                statute of any Provincial or Federal Government of Pakistan
                <strong>. </strong>
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Insurance: </strong>
              </li>
              <ul>
                <li>
                  <span dir="ltr"> </span>Unless otherwise expressly agreed in
                  writing, no insurance will be effected by TCS in respect of
                  the Shipper/Client/Sender's parcel/goods/cargo.{" "}
                </li>
                <li>
                  <span dir="ltr"> </span>Should the Shipper/Client/Sender
                  require protection against loss or damage to a Shipment and if
                  allowed by the terms of agreement, he must notify TCS before
                  tendering the shipment, stating the nature and value of the
                  goods and the destination of the shipment, specifying the
                  arrangements required. Any such additional cover will incur
                  further charges to the Shipper/Client/Sender so that shipments
                  will be subjected to an Insurance policy. The premium for such
                  cover will be quoted as an Insurance premium and be specific
                  to the individual shipment tendered. Any such insurance cover
                  would be subject to such terms and conditions as the insurer
                  would stipulate.{" "}
                </li>
                <li>
                  <span dir="ltr"> </span>In any event and for the avoidance of
                  doubt any cover arranged will not cover the
                  Shipper/Client/Sender for Consequential Loss and TCS is not
                  liable for Consequential Loss howsoever caused.{" "}
                </li>
              </ul>
              <br />
              <li>
                <span dir="ltr"> </span>
                <strong>Lawfulness of Shipment/Goods:</strong>
              </li>
              <ul>
                <li>
                  <span dir="ltr"> </span>It is hereby undertaken and confirmed
                  that the shipment/goods being stored/transported hereunder
                  through TCS have been acquired by the Shipper/Client/Sender
                  lawfully and no law whatsoever has been breached in
                  acquisition thereof. It is further undertaken and confirmed
                  that all the relevant and necessary documents pertaining to
                  the shipments/goods are in possession of Shipper/Client/Sender
                  who will be liable and responsible to provide all and any
                  document as and when required by TCS for their onward
                  submission to any Government Agency/Department/Authority etc.
                </li>
                <li>
                  <span dir="ltr"> </span>It is further undertaken and confirmed
                  that the Shipper/Client/Sender shall make himself and/or any
                  documents whatsoever available at all material times and in
                  the event that TCS and/or any Government
                  Agency/Department/Authority etc. has any query in relation to
                  all and any aspect of shipments/goods.
                </li>
                <li>
                  <span dir="ltr"> </span>It is further undertaken and declared
                  that TCS being only responsible for warehousing/transportation
                  of shipments/goods of Shipper/Client/Sender, any liability,
                  loss, claim, demand, action, proceeding etc. as may occasion
                  to TCS shall be made good and be fully indemnified by the
                  Shipper/Client/Sender in relation thereto.
                </li>
              </ul>
              <br />
              <li>
                <span dir="ltr"> </span>
                <strong>
                  If the Shipper/Client/Sender Has Asked TCS To Bill The
                  Receiver/Third Party:
                </strong>
              </li>
              <p>
                The Shipper/Client/Sender agrees to pay all shipment charges and
                destination duties, levies and taxes, for the shipment if the
                receiver or third party does not pay with TCS retaining the
                right to hold onto such shipment/goods/cargo until such payment
                is made.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Warsaw Convention:</strong>
              </li>
              If the transportation of a shipment involves an ultimate
              destination or stop in a country other than the country of
              departure, the Warsaw Convention will apply.
              <br />
              <p>
                The Warsaw Convention governs, and in most cases furthers
                limits, TCS`s liability for loss or damage to such a shipment.
                <strong> </strong>
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Oversized/Odd Sized Shipment:</strong>
              </li>
              <p>
                Additional charges for lifter/cranes, special handling would
                also apply along with agreed rates and the shipment weight would
                be charged gross or volumetric whichever will be higher at the
                time of its final weighing by TCS.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>
                  Variable Fuel Adjustment Would be Applicable As Per
                  Practice/Arrangements:
                </strong>
              </li>
              <p>
                All the rates/charges pertaining to the shipments shall be
                subjected to fluctuation of prices in the fuel and TCS`s
                decision regarding the same shall be final and binding as per
                the business arrangement.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Deliverables and Non-Deliverables:</strong>
              </li>
              <p>
                Shipments cannot be delivered to PO boxes. Shipments are
                delivered to the Receiver&rsquo;s address given by
                Shipper/Client/Sender (which in the case of mail services shall
                be deemed to be the first receiving postal service) but not
                necessarily to the named Receiver personally. Shipments to
                addresses with a central receiving area will be delivered to
                that area. If the Shipment is deemed to be unacceptable, or it
                has been undervalued for customs purposes, or Receiver cannot be
                reasonably identified or located, or Receiver refuses delivery
                or to pay for delivery, TCS shall use reasonable efforts to
                return the Shipment to Shipper /Client/Sender at his cost,
                failing which the Shipment may be released, disposed of or sold
                by TCS without incurring any liability whatsoever to
                Shipper/Client/Sender or anyone else, with the proceeds applied
                against service charges and related administrative costs and the
                balance of the proceeds of a sale to be returned to
                Shipper/Client/Sender.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Routing: </strong>
              </li>
              <p>
                Shipper/Client/Sender agrees to all routing and diversion,
                including the possibility that the Shipment may be carried via
                intermediate stopping places.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>Governing Laws: </strong>
              </li>
              <p>
                Any dispute arising under or in any way connected with these
                Terms and Conditions shall be subject, for the benefit of TCS,
                to the non-exclusive jurisdiction of the courts of, and governed
                by the law of, the country of origin of the Shipment and Shipper
                irrevocably submits to such jurisdiction, unless contrary to
                applicable law.
              </p>
              <li>
                <span dir="ltr"> </span>
                <strong>CNIC Consent: </strong>
              </li>
              <p>
                For international shipments, the Shipper/Sender/Client hereby
                agrees to share a copy of their valid CNIC with TCS, pursuant to
                requirements prescribed by law enforcement authorities to combat
                the transportation of illegal, counterfeit, and contraband
                items. TCS shall have the right to share such copy of the CNIC
                with law enforcement agencies, if and when required. TCS shall
                also have the right to share the same with its international
                courier and logistics partners, if needed, for the same reason
                of submission to law enforcement agencies, if and when required.
              </p>
              <p>
                <li>
                  <strong>Important Note: </strong>
                </li>
                <br />
                By the terms and conditions set out above, TCS and its servants
                and agents are firstly not liable at all for certain losses and
                damages and secondly wherever they are to be liable, the amount
                of liability is strictly limited to the amount stated above.
                Shipper/Client/Sender is therefore advised to purchase insurance
                cover to ensure that their risk and interest are covered. <br />
                The shipper/Client/Sender hereby undertake and acknowledge that
                entire responsibility for payment of duties, taxes, levies,
                charges etc. if any, applicable on the shipment rests with it,
                which has been fully discharged / paid to government treasury.
                In case of any issue pertaining to payment of duties, taxes etc.
                applicable, shipper/Client/Sender will be solely responsible to
                satisfy the relevant authorities accordingly, keeping TCS, its
                agents, employees, franchisee &amp; directors completely free of
                these responsibilities.
              </p>
              The invalidity or unenforceability of any provision shall not
              affect any other part of these Terms and Conditions.
            </ol>
          </td>
        </tr>
      </table>
    </div>
  </>
);

export default termsNconds;
